// Space Supremacy — server-authoritative save API (shared platform JWT).
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api/space`;
const token = () => localStorage.getItem("mist_token") || "";

async function req(path, opts = {}) {
  const r = await fetch(`${API}${path}`, {
    ...opts,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}`, ...(opts.headers || {}) },
  });
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    const err = new Error(e.detail || `HTTP ${r.status}`);
    err.status = r.status;
    throw err;
  }
  return r.json();
}

export const spaceApi = {
  getState: () => req("/state"),
  build: (plot_id, type) => req("/build", { method: "POST", body: JSON.stringify({ plot_id, type }) }),
  upgradeStructure: (plot_id) => req("/upgrade-structure", { method: "POST", body: JSON.stringify({ plot_id }) }),
  upgradeCC: () => req("/upgrade-cc", { method: "POST" }),
  syncProgress: (payload) => req("/sync-progress", { method: "POST", body: JSON.stringify(payload) }),
  adminReset: () => req("/admin/reset", { method: "POST" }),
  gameAssets: () => req("/assets"),
  conquestMap: () => req("/conquest/map"),
  conquestEnter: () => req("/conquest/enter", { method: "POST" }),
  conquestPreflight: (slot) => req(`/conquest/preflight?slot=${slot}`),
  conquestAttack: (slot) => req("/conquest/attack", { method: "POST", body: JSON.stringify({ slot }) }),
  conquestResolve: (march_id) => req("/conquest/march/resolve", { method: "POST", body: JSON.stringify({ march_id }) }),
  conquestRevenge: () => req("/conquest/revenge"),
  conquestIncoming: () => req("/conquest/incoming"),
  conquestLeaderboard: () => req("/conquest/leaderboard"),
  conquestAlliance: (slot, action = "form") => req("/conquest/alliance", { method: "POST", body: JSON.stringify({ slot, action }) }),
  skinsGet: () => fetch(`${process.env.REACT_APP_BACKEND_URL}/api/space/skins`, { headers: { Authorization: `Bearer ${localStorage.getItem("mist_token") || ""}` } }).then((r) => r.json()),
  skinsBuy: (skin_id, currency = "tokens") => req("/skins/buy", { method: "POST", body: JSON.stringify({ skin_id, currency }) }).catch((e) => { throw e; }),
  skinsEquip: (skin_id) => req("/skins/equip", { method: "POST", body: JSON.stringify({ skin_id }) }),
  heroesRoster: () => req("/heroes"),
  heroesCombat: () => req("/heroes/combat"),
  heroesDeploy: (squad) => req("/heroes/deploy", { method: "POST", body: JSON.stringify({ squad }) }),
  arenaOpponent: () => req("/heroes/arena/opponent"),
  arenaChallenge: () => req("/heroes/arena/challenge", { method: "POST" }),
  baseStaff: () => req("/heroes/workers"),
  assignStaff: (worker_id) => req("/staff/assign", { method: "POST", body: JSON.stringify({ worker_id }) }),
  unassignStaff: (worker_id) => req("/staff/unassign", { method: "POST", body: JSON.stringify({ worker_id }) }),
  roadPatrolClaim: (surviving_troops, weapon_tier) => req("/road-patrol/claim", { method: "POST", body: JSON.stringify({ surviving_troops, weapon_tier }) }),
};
